import Service, { service } from '@ember/service';

export default class HardwareInputDefRepoService extends Service {
  hardwareInputDefs = this.store.peekAll('hardware-input-def');

  @service store;

  createHardwareInputDef(defParams) {
    const def = this.store.createRecord('hardware-input-def', defParams);

    def.task.taskConfigs.forEach((taskConfig) => {
      this.store.createRecord('hardware-input-def-config', {
        hardwareInputDef: def,
        taskConfig,
      });
    });
    return def;
  }

  deleteHardwareInputDef(def) {
    def.hardwareInputDefConfigs.forEach(config => { config.deleteRecord(); });
    def.deleteRecord();
  }
}
